import '@microfrontends/app-shell-v2/dist/index.css'
import '@microfrontends/react-components/public/index.css'
import 'cropperjs/dist/cropper.css'
import vi from 'date-fns/locale/vi'
import { NextPage } from 'next'
import type { AppProps } from 'next/app'
import React, { ReactElement, ReactNode } from 'react'
import { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import sentryHelper from '../helpers/sentryHelper'
import '../styles/app.scss'
import '../styles/globals.css'

/* Init Sentry */
sentryHelper.initSentry()

/* Register the language */
registerLocale('vi', vi)

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
    getLayout?: (page: ReactElement) => ReactNode
}

type AppPropsWithLayout = AppProps & {
    Component: NextPageWithLayout
}

/* Render the App */
function MyApp({ Component, pageProps }: AppPropsWithLayout) {
    // Use the layout defined at the page level, if available
    const getLayout = Component.getLayout ?? ((page) => page)

    return getLayout(<Component {...pageProps} />)
}

export default MyApp
